var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "calendar-package" },
    [
      !_vm.isapplets
        ? _c(
            "div",
            { staticClass: "header" },
            [
              _c("van-icon", {
                attrs: { name: "arrow-left", size: "20", color: "#333" },
                on: { click: _vm.goBack }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "title" }, [_vm._v("课程日历")]),
              _vm._v(" "),
              _c("span", { staticClass: "exp" })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "record_content" },
        [
          _c("el-calendar", {
            attrs: { "first-day-of-week": 7 },
            scopedSlots: _vm._u([
              {
                key: "dateCell",
                fn: function(ref) {
                  var date = ref.date
                  var data = ref.data
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "div-Calendar",
                        on: {
                          click: function($event) {
                            return _vm.calendarOnClick(data)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "every-date" }, [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                data.day
                                  .split("-")
                                  .slice(2)
                                  .join("-")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _vm.dealMyDate(data.day, "1") > 0
                            ? _c("div", { staticClass: "red_dot" })
                            : _vm._e()
                        ])
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "live_detail" },
            [
              _vm.newList.length == 0
                ? _c("div", { staticClass: "nodata" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("p", [_vm._v("当天暂无直播")])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.newList, function(item, i) {
                return _c(
                  "li",
                  {
                    key: i,
                    on: {
                      click: function($event) {
                        return _vm.go_zhibo(item)
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "circle" }),
                    _vm._v(" "),
                    _c("div", [
                      _c("p", { staticClass: "lesson_time" }, [
                        _vm._v(
                          _vm._s(_vm._f("localDateH")(item.start_time)) +
                            " - " +
                            _vm._s(_vm._f("localDateH")(item.end_time)) +
                            "\n                "
                        ),
                        item.start_time - 3600 < new Date().getTime() / 1000 &&
                        new Date().getTime() / 1000 < item.end_time - 0 + 3600
                          ? _c("span", { staticClass: "lesson_tag" }, [
                              _c("img", {
                                attrs: {
                                  src: require("../../../static/images/living.gif"),
                                  alt: ""
                                }
                              }),
                              _vm._v("正在直播\n                ")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item.end_time - 0 + 3600 <
                          new Date().getTime() / 1000 && item.offline_code
                          ? _c("span", { staticClass: "lesson_tag" }, [
                              _vm._v("看回放")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item.end_time - 0 + 3600 <
                          new Date().getTime() / 1000 && item.offline_code == ""
                          ? _c("span", [_vm._v("已结束")])
                          : _vm._e(),
                        _vm._v(" "),
                        item.start_time - 3600 > new Date().getTime() / 1000
                          ? _c("span", [_vm._v("未开始")])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "lesson_name" }, [
                        _vm._v(_vm._s(item.lesson_name))
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "lesson_packname" }, [
                        _vm._v(_vm._s(item.package_name))
                      ])
                    ])
                  ]
                )
              })
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.zujian_flag
        ? _c("div", { staticClass: "class_dialog" }, [
            _c("div", { staticClass: "dialog_box" }, [
              _c("div", { staticClass: "dialog_message" }, [
                _vm._v("手机浏览器暂不支持查看该课件"),
                _c("br"),
                _vm._v('你可在"' + _vm._s(_vm.appname) + '"进行查看')
              ]),
              _vm._v(" "),
              _c("p", [
                _c("span", { on: { click: _vm.cancel_flag } }, [
                  _vm._v("取消")
                ]),
                _vm._v(" "),
                _vm.android
                  ? _c("span", { staticClass: "goapp" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              _vm.scheme +
                              "?type=1&orderSn=" +
                              _vm.sn +
                              "&owner=" +
                              this.$route.query.owner +
                              "&channel=" +
                              this.$route.query.channel +
                              "&orgn=" +
                              this.$route.query.orgn
                          },
                          on: { click: _vm.search_flag }
                        },
                        [_vm._v("打开APP")]
                      )
                    ])
                  : _vm.ios
                  ? _c(
                      "span",
                      { staticClass: "goapp", on: { click: _vm.search_flag } },
                      [_vm._v("去APP查看")]
                    )
                  : _vm._e()
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.applets_flag && _vm.ios
        ? _c("popup", {
            staticClass: "popop_content",
            attrs: { type: 1 },
            on: { isopen: _vm.popup }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.applets_flag && _vm.android
        ? _c("popup", {
            staticClass: "popop_content",
            attrs: { type: 2 },
            on: { isopen: _vm.popup }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.arshow ? _c("arouse", { on: { arouse: _vm.receive } }) : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        attrs: { src: require("../../../static/images/nodata.png"), alt: "" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19e2d78f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19e2d78f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/calendar.vue
// module id = null
// module chunks = 